import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Button, Header, Screen, Text } from '@components'
import { useLanguage } from '@context'
import { Theme } from '@theme'

interface AccessDeniedProps {
  /** Why nothing is shown (already translated). */
  message: string
  onBack: () => void
  testID?: string
}

/** Shown instead of a screen the person has no right to see (or that does not exist). */
export const AccessDenied: React.FC<AccessDeniedProps> = ({ message, onBack, testID }) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyles(theme)
  return (
    <Screen>
      <Header title={t('events.access.title')} iconLeft="arrowBack" onPressLeft={onBack} />
      <View style={styles.body} testID={testID ?? 'access-denied'}>
        <Text type="titleBold">{t('events.access.title')}</Text>
        <Text type="body" color={theme.colors.greyBlue} style={styles.text}>
          {message}
        </Text>
        <Button title={t('events.access.back')} isSmall unfilled onPress={onBack} />
      </View>
    </Screen>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    body: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: theme.spacing.xl, gap: theme.spacing.md },
    text: { textAlign: 'center' },
  })
